import {mount} from "svelte";
import SearchIcon from "./components/headerItems/SearchToggle.svelte";

mount(SearchIcon, {
  target: document.querySelector("#squirrel_searchIcon")!.parentElement as HTMLElement
})